import React from "react";
import { designImg, fmtDate } from "./designsApi";
import { CategoryChips } from "./Categories";

export const DesignCard = ({ d, onOpen }) => (
  <button type="button" onClick={() => onOpen(d)} data-testid={`design-card-${d.serial_label || d.order_number}`}
    className="group text-left rounded-sm border border-slate-800 bg-slate-900/50 overflow-hidden hover:border-orange-500/70 transition-colors">
    <div className="px-3 pt-2 pb-1 flex items-baseline justify-between gap-2">
      <span className="font-mono-num text-2xl font-black text-orange-400 leading-none" data-testid="design-card-serial">
        {d.serial_label || "D-…"}
      </span>
      <span className="flex gap-1">
        {d.group_size > 1 && d.group_main && <span className="text-[10px] text-cyan-300 border border-cyan-400/40 px-1 rounded-sm" data-testid="design-card-group">+{d.group_size - 1} same</span>}
        {(d.cat_review || d.group_doubt) && <span className="text-[10px] text-amber-300 border border-amber-400/40 px-1 rounded-sm">REVIEW</span>}
        {d.superseded && <span className="text-[10px] text-amber-300 border border-amber-400/40 px-1 rounded-sm">PURANA VERSION</span>}
      </span>
    </div>
    <div className="aspect-square bg-slate-200 flex items-center justify-center overflow-hidden">
      <img src={designImg(d.id, true, d.rendered_at)} alt={d.serial_label || d.order_number} loading="lazy"
        className="max-w-full max-h-full object-contain group-hover:scale-[1.03] transition-transform duration-300" />
    </div>
    <div className="p-3 space-y-0.5">
      <div className="font-mono-num text-sm font-bold text-slate-200">#{d.order_number}</div>
      <div className="text-sm text-slate-100 truncate">{d.customer_name}</div>
      <div className="text-xs text-slate-400 font-mono-num truncate">{d.plate_size}</div>
      <div className="text-[11px] text-slate-500 truncate">{fmtDate(d.file_uploaded_at || d.order_date)}{d.sheet_type ? ` · ${d.sheet_type}` : ""}</div>
      <div className="pt-1"><CategoryChips d={d} small /></div>
    </div>
  </button>
);
